import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../environments/environment';

/* const supabase = createClient('https://dbselptcqkmrifegpqfk.supabase.co', environment.SUPABASE_CLIENT_KEY) Evolvo Dev */
const supabase = createClient(environment.SUPABASE_PROJECT_URL, environment.SUPABASE_CLIENT_KEY)

@Injectable({
  providedIn: 'root'
})
export class SupabaseClientService {

  constructor(){}

  public get client(): SupabaseClient {
    return supabase
  }
}
